import { useHistory } from "react-router-dom";
import { usePubContext } from "../../hooks/pub-context";
import { enqueueSnackbar } from "notistack";
import useUserInfo from "../../../../../hooks/useUserInfo";
import { likeAdd, likeDelete, likeHasItems } from "../../../../../api/like";
import { useEffect, useState } from "react";
import Header from "../../../../../components/header";

const PremiumPubHeader = () => {
  const history = useHistory();
  const { user } = useUserInfo();
  const { showHeader, data } = usePubContext();
  const [like, setLike] = useState(data?.like);

  useEffect(() => {
    if (!data) return;
    setLike(data?.like);
  }, [data]);

  const handleToggleLike = async () => {
    if (!data) return;
    if (!user) {
      history.push("/login", { redirect: window.location.href });
      enqueueSnackbar("로그인이 필요합니다.", { variant: "error" });
      return;
    }

    try {
      const { hasLike } = await likeHasItems(data.id);
      if (!hasLike) {
        await likeAdd(data.id);
        enqueueSnackbar("즐겨찾기에 추가되었습니다.", { variant: "success" });
        setLike(true);
      } else {
        await likeDelete(data.id);
        enqueueSnackbar("즐겨찾기에서 삭제되었습니다.", {
          variant: "success",
        });
        setLike(false);
      }
    } catch (e) {
      enqueueSnackbar("즐겨찾기 업데이트에 실패했습니다. ", {
        variant: "error",
      });
    }
  };

  const getLikeImageUrl = () => {
    if (like) return "vip_heart_on";
    if (!showHeader) return "vip_heart_scroll";
    return "vip_heart";
  };

  return (
    <Header
      title={data?.cafeName || ""}
      show={showHeader}
      buttonClick={handleToggleLike}
      img={`/image-web/store/${getLikeImageUrl()}.png`}
      imgSize="31px"
    />
  );
};

export default PremiumPubHeader;
